import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledPropertyCardPhotoBody } from './PropertyCardPhotoBody.styles';

/**
 * A container for the property photo in a `PropertyCard`.
 *
 * @since 8.63.0
 */
export var PropertyCardPhotoBody = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledPropertyCardPhotoBody, _extends({
    ref: forwardedRef
  }, props));
});
PropertyCardPhotoBody.displayName = 'PropertyCard.PhotoBody';